module.exports = "<h1 id=\"空状态--d-empty\">空状态  d-empty</h1>\n<p>该组件转自ant-design</p>\n";